module.exports = __webpack_public_path__ + "7fdcd500420537104db1bb953fbbcfca.svg";